import { InvoiceHistory } from '@weave/schema-gen-ts/dist/schemas/payments/views/service/service.pb';
import { formatDate } from '@frontend/date';
import { Icon } from '@frontend/icons';
import { theme } from '@frontend/theme';
import { Text } from '@frontend/design-system';
import { useGetRequestActivityMap } from '../request-activity-map';
import { styles } from './styles';
import { TaggedUser } from './tagged-user';

type ActivityRowProps = {
  action: InvoiceHistory;
  compactView: boolean;
  userChipAtBottom?: boolean;
};
export const ActivityRow = ({ action, compactView, userChipAtBottom }: ActivityRowProps) => {
  const actionMap = useGetRequestActivityMap(action);

  // Derived values
  const iconSize = compactView ? 16 : 24;
  const titleSize = compactView ? 'small' : 'large';
  const titleWeight = compactView ? 'bold' : 'regular';
  const showUserInline = userChipAtBottom || compactView;
  const showUserOnRight = !compactView && !userChipAtBottom;
  const userVariant = userChipAtBottom ? 'chip' : 'badge';

  // Computed styles
  const userContainerStyle = compactView ? {} : { marginTop: theme.spacing(1) };

  return (
    <div className='activity-row' css={[styles.activityRow, styles.marginBottom]} key={action.id}>
      <div className='activity-row__detail' css={styles.activityDetail(compactView)}>
        <div className='activity-row__icon' css={{ marginTop: theme.spacing(0.5) }}>
          <Icon name={actionMap?.icon} size={iconSize} />
        </div>

        <div className='activity-row__content'>
          <Text size={titleSize} weight={titleWeight}>
            {actionMap?.title}
          </Text>
          <Text size='small' color='light' css={styles.blackInk}>
            {formatDate(action?.createdAt, 'MMM D, YYYY, h:mma')}
          </Text>

          {showUserInline && (
            <div className='activity-row__user-container' css={userContainerStyle}>
              <TaggedUser userId={action?.userId} variant={userVariant} />
            </div>
          )}
        </div>
      </div>

      {showUserOnRight && <TaggedUser userId={action?.userId} variant='chip' />}
    </div>
  );
};
